import { FileImportType } from 'types/import-type';

/**
 * Display order of the column-selection rows, one list per import type. Without it the rows come
 * out in the generated enums' own order, which is alphabetical and puts the keys anywhere.
 */
export const IMPORT_FIELD_ORDER: Record<string, string[]> = {
  [FileImportType.ProductColor]: [
    'SeasonCode',
    'ProductCode',
    'ColorCode',
    'CustomFieldValue_1',
    'CustomFieldValue_2',
    'CustomFieldValue_3',
    'CustomFieldValue_4',
    'CustomFieldValue_5',
    'GenericReference',
    'HasCondition',
    'HasStockMax',
    'HasStockMin',
    'IsOnShowcase',
    'IsSync',
    'NewSeasonCode',
    'ProductModuleName',
    'ProductStrength',
    'SizeSystemRowName',
    'StockMaxStoreStrengthCondition',
    'StockMinStoreStrengthCondition',
  ],
  [FileImportType.ProductColorSize]: [
    'SeasonCode',
    'ProductCode',
    'ColorCode',
    'SizeSystemHeaderName',
    'StockMaxStoreStrengthConditionValue',
    'StockMaxValue',
    'StockMinStoreStrengthConditionValue',
    'StockMinValue',
  ],
  [FileImportType.ProductColorSizeStore]: [
    'UniverseCode',
    'SeasonCode',
    'StoreCode',
    'ProductCode',
    'ColorCode',
    'SizeSystemHeaderName',
    'ArticleOptimalStockException',
  ],
  [FileImportType.ProductColorStore]: [
    'UniverseCode',
    'SeasonCode',
    'ProductCode',
    'ColorCode',
    'StoreCode',
    'StoreAction',
  ],
  [FileImportType.Store]: [
    'UniverseCode',
    'StoreCode',
    'StoreType',
    'CustomFieldValue_1',
    'CustomFieldValue_2',
    'CustomFieldValue_3',
    'CustomFieldValue_4',
    'CustomFieldValue_5',
    'HandleShowcase',
    'IsActive',
    'PickingPriority',
  ],
  [FileImportType.StoreSeason]: [
    'UniverseCode',
    'SeasonCode',
    'StoreCode',
    'Capacity',
    'TargetTurnover',
    'IsSynced',
    'StoreGroupName',
    'IgnoreMinMax',
  ],
  [FileImportType.StoreSeasonPermutationFields]: [
    'UniverseCode',
    'SeasonCode',
    'StoreCode',
    'PermutationFields',
    'ValidatedStrength',
  ],
};

/**
 * Orders the fields of one import type. A field absent from the list goes last, in the order it
 * came: a newly added field stays importable instead of vanishing from the screen.
 */
export const orderImportFields = (importType: string, fields: string[]): string[] => {
  const order = IMPORT_FIELD_ORDER[importType];

  if (!order) return fields;

  const rank = (field: string) => {
    const index = order.indexOf(field);

    return index === -1 ? order.length : index;
  };

  return [...fields].sort((a, b) => rank(a) - rank(b));
};
